// src/components/Products/Special.jsx
import { useConfig } from "../../contexts/ConfigContext";

// Direct imports for critical components (no lazy loading to prevent cascade)
import SpecialCardv1 from '../ProductsView/SpecialCard/SpecialCardv1';
import SpecialCardv2 from '../ProductsView/SpecialCard/SpecialCardv2';

const Special = ({ special, singleSpecialView, setSelectedSpecialId }) => {
    const { themeConfig } = useConfig();
    return (
        <>
            {themeConfig.specialsCardTheme && themeConfig.specialsCardTheme === 'v1' ? (
                <SpecialCardv1
                    special={special}
                    menuSpecials={true}
                    singleSpecialView={singleSpecialView}
                    setSelectedSpecialId={setSelectedSpecialId}
                />
            ) : (
                <SpecialCardv2
                    special={special}
                    menuSpecials={true}
                    singleSpecialView={singleSpecialView}
                    setSelectedSpecialId={setSelectedSpecialId}
                />
            )}
        </>
    );
};

export default Special;
